import { useEffect } from 'react'

export const usePageVisibility = (
  onHidden: () => void,
  onVisible: () => void,
) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        onHidden()
      } else {
        onVisible()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [onHidden, onVisible])
}
